<div class="container-fluid" [ngStyle]="isDarkTheme ?{'background-color':'#000000'} : {'background-color': '#ffffff'}">
    <app-Side_Navigation></app-Side_Navigation>
    <router-outlet></router-outlet>
</div>


